import styled from 'styled-components';

export const Selection = styled.div`
  display: block;
  height: 40px;
  margin: 10px 0;
  border-radius: 8px;
  padding: 0 12px;
  max-width: auto;
  font-weight: semi-bold;
`

export const LabelContainer = styled.div`
  display: inline-block;

`
//conditional label colors
export const Label = styled.div`
  display: inline-block;
  font-size: 14px;
  background-color: ${props => props.color};
  padding: 4px 10px;
  font-weight: 500;
`
